// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_gd-0";
export var fileCarousel = "_gd-2";
export var removeFileButton = "_gd-1";